export default __webpack_public_path__ + "static/media/crown-light.ef678ac0.svg";